import { render, staticRenderFns } from "./VideoImgAndVideoFansAndComment.vue?vue&type=template&id=65bd15a1&"
import script from "./VideoImgAndVideoFansAndComment.vue?vue&type=script&lang=js&"
export * from "./VideoImgAndVideoFansAndComment.vue?vue&type=script&lang=js&"
import style0 from "./VideoImgAndVideoFansAndComment.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideoImgAndVideoFansAndComment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports